import Icon from 'assets/app_logo.svg'
import styled from 'styled-components'
import OpenTheAppDownloadButton from 'components/modules/SEO/OpenTheAppDownloadButton'
import { getDefaultMetaTitle } from 'lib/constants/language'
import { useRouter } from 'next/router'
import { ButtonText, Caption } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'

const Container = styled.div<{
    isDialog?: boolean
    backgroundColor?: string
}>`
    position: ${({ isDialog }) => (isDialog ? 'absolute' : 'fixed')};
    bottom: 0px;
    left: 0px;
    width: 100%;
    overflow: hidden;
    background: ${theme.colors.blueIce};
    height: 100px;
    z-index: ${theme.zIndex.FAB};
    display: grid;

    .content {
        display: grid;
        grid-template-columns: 50px 1fr auto;
        padding: 10px 20px;
        grid-gap: 10px;
        place-items: center;
        position: relative;
    }
`

interface Props {
    onDownloadButtonClick(platform: 'android' | 'ios'): void
    isDialog?: boolean
    mobileOS: 'ios' | 'android'
    downloadDeepLinkPath?: string
}

const MobileFixedConversionBanner = (props: Props) => {
    const { locale } = useRouter()
    const appMotto = getDefaultMetaTitle(locale)

    return (
        <Container isDialog={!!props.isDialog}>
            <div className="content">
                <Icon />
                <div>
                    <ButtonText color={theme.colors.accentBlue}>Knowunity</ButtonText>
                    <Caption color={theme.colors.accentBlue} fontWeight={600}>
                        {appMotto}
                    </Caption>
                </div>
                <OpenTheAppDownloadButton
                    onClick={() => props.onDownloadButtonClick(props.mobileOS)}
                    downloadDeepLinkPath={props.downloadDeepLinkPath}
                    referrerScreen="knowContentDialogBottomSignUpButton"
                    isDark
                    backgroundColor={theme.colors.accentBlue}
                />
            </div>
        </Container>
    )
}

export default MobileFixedConversionBanner
